import { render, staticRenderFns } from "./ProductClose.vue?vue&type=template&id=64de94cf&scoped=true&"
import script from "./ProductClose.vue?vue&type=script&lang=js&"
export * from "./ProductClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64de94cf",
  null
  
)

export default component.exports